import { v4 } from 'uuid';

export const createInitialValue = () => ({
  _key: v4(),
});
